import { Module } from 'vuex';

import actions from './actions';
import mutations from './mutations';

export const state: Store.Events.State = {
  secret: '',
  events: [],
  total: 0,
};

const namespaced = true;

export const events: Module<Store.Events.State, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
};
